export default __webpack_public_path__ + "static/media/the_rev.f75ca478.jpeg";